import LongRestPane from "./LongRestPane";

export default LongRestPane;
export { LongRestPane };
